var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPtFlag(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_913_1112",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 25
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 25C19.4036 25 25 19.4036 25 12.5C25 5.59644 19.4036 0 12.5 0C5.59644 0 0 5.59644 0 12.5C0 19.4036 5.59644 25 12.5 25Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_913_1112)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 25H8.1543L10.0049 12.29L8.1543 0H0V25Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 0H8.1543V25H25V0Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.1543 16.8457C10.5544 16.8457 12.5 14.9001 12.5 12.5C12.5 10.0999 10.5544 8.1543 8.1543 8.1543C5.75423 8.1543 3.80859 10.0999 3.80859 12.5C3.80859 14.9001 5.75423 16.8457 8.1543 16.8457Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.70801 10.3271V13.0371C5.70801 13.6853 5.96548 14.3069 6.42379 14.7652C6.8821 15.2235 7.50371 15.481 8.15186 15.481C8.8 15.481 9.42161 15.2235 9.87992 14.7652C10.3382 14.3069 10.5957 13.6853 10.5957 13.0371V10.3223H5.71289L5.70801 10.3271Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.1543 13.8574C7.70508 13.8574 7.33887 13.4912 7.33887 13.042V11.9629H8.96973V13.0371C8.96973 13.4863 8.60352 13.8525 8.1543 13.8525V13.8574Z",
    fill: "#EEEEEE"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPtFlag);
export default __webpack_public_path__ + "static/media/pt_flag.9c212e24b29b8c43278d87a5501635dd.svg";
export { ForwardRef as ReactComponent };